/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import moment from 'moment';

// Component imports
import { Form, Radio } from 'antd';
import CustomRangePicker from '../../Forms/Fields/CustomRangePicker';

// Misc imports
import { getPresetDateRanges } from '../../../constants/main';

const LiveChatDateFilter = ({ organization, form, ...formItemProps }) => {
  const { t } = useTranslation();
  const [, updateState] = useState(); // Hook to force a component re-render
  const orgTimezone = organization?.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

  const handleOnChange = (dates) => {
    // Trigger the formItemProps.onChange if it exists
    if (formItemProps.onChange) {
      formItemProps.onChange(dates);
    }

    // Update the state
    updateState(dates);
  };

  return (
    <Fragment>
      <Radio.Group
        className="d-flex flex-column"
        options={[
          {
            label: t('All dates'),
            value: '',
            style: { marginBottom: 4 }
          },
          {
            label: t('Today'),
            value: moment.tz(new Date(), organization?.timezone).startOf('day').format(),
            style: { marginBottom: 4 }
          },
          {
            label: t('Last week'),
            value: moment.tz(new Date(), organization?.timezone).subtract(7, 'days').startOf('day').format(),
            style: { marginBottom: 4 }
          },
          {
            label: t('Last month'),
            value: moment.tz(new Date(), organization?.timezone).subtract(30, 'days').startOf('day').format(),
            style: { marginBottom: 4 }
          },
          {
            label: t('Custom date range'),
            value: 'custom',
            style: { marginBottom: 4 }
          }
        ]}
        onChange={(e) => handleOnChange(e.target.value)}
        {...formItemProps}
      />

      <div className="px-5 mb-3">
        <Form.Item name="customDate">
          <CustomRangePicker
            disabled={form.getFieldValue('date') !== ('custom')}
            allowClear={false}
            allowEmpty={false}
            onChange={() => {
              handleOnChange('custom');
            }}
            ranges={getPresetDateRanges(orgTimezone)}
          />
        </Form.Item>
      </div>
    </Fragment>
  );
};

LiveChatDateFilter.propTypes = {
  organization: PropTypes.object,
  form: PropTypes.object
};

export default LiveChatDateFilter;
